import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useUserApi from "../../../services/userApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Container,
  Form,
  Row,
  Col,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";
import { GetUserInfo } from "../../../utils/permissionChecker";
import Card from "../../../components/Card";
import { toast } from "react-toastify";
const PermissionList = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const { getPermissionList, RegisterNewPermission } = useUserApi();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setFormError("");
    setShowModal(false);
  };
  const [formError, setFormError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    permissionGroupId: "",
    status: 1,
    created_by: currentUser,
    updated_by: currentUser,
  });

  const RegisterPermissionMutation = useMutation(async (newData) => {
    try {
      const result = await RegisterNewPermission(newData);
      if (result) {
        queryClient.invalidateQueries("get_permission_list");
        toast.success(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        handleCloseModal();
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  });
  const getPermissionQuery = useQuery(["get_permission_list"], () =>
    getPermissionList()
  );
  if (getPermissionQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (getPermissionQuery.isError) {
    return <div>Error: {getPermissionQuery.error.message}</div>;
  }
  const getPermission = getPermissionQuery.data;
  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const handleButtonSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.permissionGroupId) {
      setFormError("Pease fill all fields are required ");
      return;
    }
    handleCloseModal();
    try {
      setIsSubmitting(true);
      await RegisterPermissionMutation.mutate(formData);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12">
            <Card className="card-block card-stretch card-height">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center p-3">
                  <h4 className="font-weight-bold"> Permission List</h4>
                  <div className="d-flex flex-wrap align-items-center justify-content-between">
                    <Button
                      variant="btn btn-info btn-sm m-2"
                      onClick={() => handleShowModal()}
                    >
                      {t("add_new_permission")}
                    </Button>
                  </div>
                </div>
                <table>
                  <thead>
                    <tr>
                      <th>Permission Group</th>
                      <th>Permissions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getPermission.map((group) => (
                      <tr key={group.id}>
                        <td style={{ paddingRight: "20px" }}>
                          {t(group.name)}
                        </td>
                        <td>
                          {group.permissions.length > 0 ? (
                            <ul>
                              {group.permissions.map((permission) => (
                                <li key={permission.id}> {permission.name}</li>
                              ))}
                            </ul>
                          ) : (
                            " No permissions assigned"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">Add new permission </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col lg="12">
                <Form.Group>
                  <Form.Label
                    htmlFor="inputPosition"
                    className="font-weight-bold text-muted"
                  >
                    {t("permission_group")}
                  </Form.Label>
                  <select
                    id="inputPosition"
                    className="form-select form-control choicesjs"
                    value={formData.permissionGroupId}
                    onChange={(e) => handleInputChange(e, "permissionGroupId")}
                  >
                    <option value="" hidden disabled>
                      Select Group
                    </option>
                    {getPermission.map((data) => (
                      <option key={data.id} value={data.id}>
                        {t(data.name)}
                      </option>
                    ))}
                  </select>
                </Form.Group>

                <Form.Group>
                  <Form.Label className="text-secondary">
                    Permission Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter permission name"
                    value={formData.name}
                    onChange={(e) => handleInputChange(e, "name")}
                  />
                  <p className="text-danger"> {formError}</p>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {isSubmitting ? (
            <Button variant="btn-primary">
              {" "}
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="visually-hidden">Sending...</span>
            </Button>
          ) : (
            <Button
              onClick={(e) => handleButtonSubmit(e)}
              variant="btn btn-info"
            >
              Register
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PermissionList;
